import { DEFAULT_PLATFORM_LIST_FILTERS } from "./PlatformUserAccess.constants";

export const initialState = {
  loading: true,
  error: null,
  users: [],
  customers: [],
  customerRoleOptions: [],
  listFilters: { ...DEFAULT_PLATFORM_LIST_FILTERS },
  pagination: {
    page: 0,
    size: 25,
    totalCount: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
  },
  isInviteModalOpen: false,
  selectedUserId: null,
  selectedUserDetails: null,
};
